// @flow
type valuesType = {
  password?: string,
  passwordConfirmation?: string
};

type errorsType = {
  password?: string,
  passwordConfirmation?: string
};

const PASSWORD_REQUIREMENTS =
  'Password must be eight or more characters, contain at least one upper and one lower case letter, at least one number, and at least one special character (ex. @).';
const passwordPattern =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?(?:\p{S}|\p{P})).{8,}$/u;
const meetsPasswordRequirements = (password: string): boolean =>
  passwordPattern.test(password);

const validate = ({
  password,
  passwordConfirmation
}: valuesType): errorsType => {
  const errors = {};
  if (!password) {
    errors.password = 'Required';
  }

  if (!passwordConfirmation) {
    errors.passwordConfirmation = 'Required';
  }

  if (password && !meetsPasswordRequirements(password)) {
    errors.password = PASSWORD_REQUIREMENTS;
  }

  if (password !== passwordConfirmation) {
    errors.passwordConfirmation = 'Passwords do not match!';
  }

  return errors;
};

export default validate;
export { meetsPasswordRequirements, PASSWORD_REQUIREMENTS };
